<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :onFetchData="onFetchData"
    :beforeSubmit="beforeSubmit"
    :title="getTitle"
    resource="custom_lists"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../../admin_grapes/custom_lists.js';
import _ from 'lodash';
import CustomListItemColumns from './custom_list_item_columns';
import CustomListItemFormColumns from './custom_list_item_form_columns';

@Component
export default class CustomLists extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}
  menuType = null
  merchantList = []
  ticketEventList = []

  get getTitle() {
    switch (this.menuType) {
      case 'ad_space':
        return this.$t('menu.adSpace');
      case 'video_space':
        return this.$t('menu.videoSpace');
    }
    return this.$t('model.customList');
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      'name_cont',
      'code_cont',
      'is_active_eq',
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      {
        key: 'name',
        minWidth: 150,
      },
      {
        key: 'code',
        minWidth: 150,
      },
      'is_active',
      {
        key: 'kind',
        minWidth: 140,
      },
      type === 'show' && {
        prop: 'custom_list_items_attributes',
        label: this.$t('model.customListItem'),
        renderCell: (h, { props: { value, scope: { row } } }) => {
          if (value) {
            return <bean-table height={null} value={value} columns={CustomListItemColumns.call(this, row)} />
          }
        }
      },
      type === 'show' && 'created_at',
      type === 'show' && 'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [
      'name',
      {
        key: 'code',
        renderCell: {
          props: {
            disabled: type === 'edit',
          }
        }
      },
      'is_active',
      {
        key: 'kind',
        renderCell: {
          props: {
            disabled: type === 'edit',
          }
        }
      },
      data.kind !== 'merchant_list' && {
        prop: 'custom_list_items_attributes',
        label: this.$t('model.customListItem'),
        renderCell: {
          component: 'nestForm',
          props: {
            sortable: true,
            limitOne: data.kind === 'image',
            columns: (row) => {
              if (row) {
                return CustomListItemFormColumns.call(this, row, data);
              }
            },
          }
        }
      },
      data.kind === 'merchant_list' && {
        prop: 'merchants',
        label: this.$t('model.customListItem'),
        renderCell: {
          component: 'listSelect',
          props: {
            showSelectAll: true,
            label: 'name',
            onLoad: async () => {
              const { data } = await this.$request.get('/merchants/read_options');
              return data;
            },
            onFilter: async (form) => {
              const { data } = await this.$request.get('/merchants/read_options', {
                ...form,
              });
              return data;
            },
            filterColumns: [
              {
                prop: 'keyword',
                label: '',
                renderCell: {
                  component: 'input'
                }
              }
            ]
          }
        }
      },
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'custom_lists.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'custom_lists.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }

  async onFetchData({ type }) {
    this.menuType = this.$route.params.menu_type;
    if (type === 'index') {
      let params = this.$route.query;
      switch (this.menuType) {
        case 'ad_space':
          params.kind_not_eq = 'video_list';
          break;
        case 'video_space':
          params.kind_eq = 'video_list';
          break;
      }
      const { data, pagination } = await this.$request.get('/custom_lists', { params });
      return {
        data,
        pagination
      }
    }

    if (type === 'edit' || type === 'new') {
      const [merchants, ticketEvents] = await Promise.all([
        this.$request.get('/merchants/read_options', { per_page: 50 }),
        this.$request.get('/ticket_events/read_options', { per_page: 50 })
      ]);
      this.merchantList = merchants.data;
      this.ticketEventList = ticketEvents.data;
    }

    if (type === 'show' || type === 'edit') {
      const data = await this.$request.get(`/custom_lists/${this.$route.params.id}`);
      if (data.kind === 'image' && data.custom_list_items_attributes.length === 0) {
        data.custom_list_items_attributes.push({});
      }

      if (type === 'edit') {
        const merchants = data.custom_list_items_attributes.filter((item) => item.target_type === 'Merchant').map(item => {
          return {
            id: item.target_id,
            name: item.target.name
          }
        })
        const ticketEvents = data.custom_list_items_attributes.filter((item) => item.target_type === 'TicketEvent').map(item => {
          return {
            id: item.target_id,
            title: item.target.title
          }
        })
        if (data.kind === 'merchant_list') {
          data.merchants = merchants;
        }
        this.merchantList = [...new Set([...this.merchantList, ...merchants])];
        this.ticketEventList = [...new Set([...this.ticketEventList, ...ticketEvents])];

        data.custom_list_items_attributes.forEach((item) => {
          switch (item.target_type) {
            case ('Merchant'):
              item.merchant_id = item.target_id;
              break;
            case ('TicketEvent'):
              item.ticket_event_id = item.target_id;
              break;
          }
        });
      }
      return { data };
    }

    if (type === 'new') {
      return {
        cn: 'CustomList'
      }
    }
  }

  beforeSubmit({ data }) {
    const formBody = _.cloneDeep(data);
    formBody.merchant_ids = _.get(formBody, 'merchants', []).map(item => item.id);
    delete formBody.merchants;
    formBody.custom_list_items_attributes.forEach((item) => {
      switch (item.target_type) {
        case ('Merchant'):
          item.target_id = item.merchant_id;
          delete item.merchant_id;
          break;
        case ('TicketEvent'):
          item.target_id = item.ticket_event_id;
          delete item.ticket_event_id;
          break;
      }
    });
    return formBody;
  }
}

export const route = [
  {
    path: '/custom_lists/:menu_type',
    name: 'custom_lists.index',
    component: CustomLists,
    props: {
      type: 'index',
    }
  },
  {
    path: '/custom_lists/:menu_type/new',
    name: 'custom_lists.new',
    component: CustomLists,
    props: {
      type: 'new',
    }
  },
  {
    path: '/custom_lists/:menu_type/:id',
    name: 'custom_lists.show',
    component: CustomLists,
    props: {
      type: 'show',
    }
  },
  {
    path: '/custom_lists/:menu_type/:id/edit',
    name: 'custom_lists.edit',
    component: CustomLists,
    props: {
      type: 'edit'
    }
  },
]
</script>

<style scoped lang="scss">
  /deep/.admin-nest-form {
    .el-form-item {
      margin-bottom: 20px;
    }
  }
</style>

